<h4 mat-dialog-title>{{data.date}}
  <ng-container *ngIf="read">
    - Letto
  </ng-container>
  <ng-container *ngIf="warning">
  <span class="material-icons" style="vertical-align: middle; color: rgba(231,180,53,0.92)">
    report_problem
  </span>
  </ng-container>
  <ng-container *ngIf="evaluation">
    <span class="material-icons" style="vertical-align: middle; color: forestgreen">check_circle</span>
  </ng-container>
</h4>
<div mat-dialog-content style="padding-bottom: 30px;">
  <div class="container">
    <mat-card style="width: 600px; height: 300px; margin: auto" class="mat-elevation-z5">
      <canvas id="canvas" width="600" height="300" style="position: absolute; width: 600px; height: 300px; left: 0; top: 0;
          touch-action: none; user-select: none;"></canvas>
    </mat-card>
    <br><br>
  </div>
  <ng-container *ngIf="data.role.localeCompare('DOTTORE') === 0">
    <div style="text-align: center">
      <strong>Distanza: {{data.distance}} cm</strong>
      <br>
      <strong>Diagnosi: {{this.diagnosis}}</strong>
    </div>
  </ng-container>
</div>

<div mat-dialog-actions style="justify-content: center">
  <ng-container *ngIf="data.role.localeCompare('DOTTORE') === 0 && !data.id.includes('CLINICAL')">
    <button mat-raised-button color="primary" (click)="evaluate()">Valuta</button>
  </ng-container>
  <ng-container *ngIf="data.role.localeCompare('PAZIENTE') === 0">
    <button mat-raised-button color="primary" (click)="warn()">Segnala</button>
  </ng-container>
  <button mat-raised-button color="warn" (click)="cancel()">Esci</button>
</div>
